import { LOST_STAGE, STAGE_PROBABILITIES } from "@/fjdigital/config";

export interface DealBuckets {
  won: number;
  pending: number;
  lost: number;
}

export function getDealBuckets(
  deals: Array<{ stage: string; amount: number }>,
  pipelineStatuses: string[],
): DealBuckets {
  return deals.reduce(
    (acc, deal) => {
      if (pipelineStatuses.includes(deal.stage)) {
        acc.won += deal.amount;
      } else if (deal.stage === LOST_STAGE) {
        acc.lost -= deal.amount;
      } else {
        acc.pending += deal.amount * (STAGE_PROBABILITIES[deal.stage] ?? 0);
      }
      return acc;
    },
    { won: 0, pending: 0, lost: 0 },
  );
}
